package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.model.BillingStatus
import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class GetBillingStatusUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): BillingStatus? = accountRepository.getBillingStatus()
}
